import {
  sendPostRequest, sendPutRequest, sendDeleteRequest, sendGetRequest, makeGetRequest
} from "@/helper/requests";
import surveys from "@/urls/roles/admin";
import core from "@/urls/roles/creator";

const state = {

}

const getters = {
}

const mutations = {
}

const actions = {
  loadFileList: ({commit}, {url, finalizer, catcher}) => {
    /**
     * Загружает список файлов
     * @param {Function} commit - Функция для вызова мутаций
     * @param {string} url - URL для запроса списка файлов (опционально)
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if (!url)
      url = core.CREATOR.FILE.LIST()
    sendGetRequest(
      url,
      (data) => finalizer(data, url),
      catcher
    )
  },
  compiledLoadFile: ({commit}, { id, finalizer=()=>{}, catcher=()=>{}}) => {
    /**
     * Загружает информацию об обработанном файле
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор файла
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    const url = core.CREATOR.FILE.COMPLETED(id)
    sendGetRequest(
        url, (data) => {
          finalizer(data);
        }, (data) => {
          catcher(data);
        }
    )
  },
  saveLoadFile: ({commit}, { id,url }) => {
    /**
     * Скачивает файл на устройство пользователя
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор файла для скачивания
     * @param {string} url - URL для скачивания файла
     */
    // const url = core.CREATOR.FILE.DOWNLOAD(id)
    makeGetRequest(
        url
    ) .then(resp => {
      if (!resp.ok) {
        alert("Не удалось загрузить файл")
      }
      return resp.blob();
    }) .then(blob => {
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = 'Файл';
      a.click();
    })
  },
}


export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
